<template>
  <div>
    <list
      row-key="PlanDtsId"
      ref="list"
      light-row
      :page="page"
      :query-params="params"
      show-checkbox
      :tempParams="tempParams"
      :show-query="showQuery"
      :get-data-func="api.getWorkDocProductPlanList"
      @row-select="onSelect"
      @check-change="onCheck"
      v-if="trendShow"
      urlHash="production/reportmanagement/prewarehousing/toPro"
      @getDataEnd="getDataEnd"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <el-tab-pane v-for="(item, index) in stageList" :key="index" :label="item.StageName + '(' + item.Count + ')'" :name="item.Stage + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" @click.stop="report(row)">报工</el-button> -->
            <el-button type="text" @click.stop="report(row)">普通入库</el-button>
            <el-button type="text" @click.stop="reportTest(row)">按箱入库</el-button>
          </template>
        </el-table-column>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- <h2 style="font-weight: 400; color:#303133;font-size: 18px;margin-left: 5px;">工单信息</h2> -->
    <!-- <info1 ref="info0" v-if="tabName == 0" style="margin-top: 20px" :data="infoData" :repData="reportData" />
    <info2 ref="info1" v-else style="margin-top: 20px" :data="infoData" :repData="reportData" /> -->
    <!-- <info3 ref="info2" v-if="tabName==2" style="margin-top: 20px;" :data="infoData"/>
    <info4 ref="info3" v-if="tabName==3" style="margin-top: 20px;" :data="infoData" />
    <info5 ref="info4" v-if="tabName==4" style="margin-top: 20px;" :data="infoData" /> -->
    <el-tabs v-model="tabName1" type="card" v-if="false">
      <el-tab-pane label="报工明细" name="report">
        <!-- 报工时间，报工单重，合格重量，合格数量、不合格重量，不合格数量，明细 -->
        <el-table class="tb-c-head" :data="reportData" border>
          <el-table-column label="报工时间" prop="AddTime" />
          <el-table-column label="报工单重" prop="Grammage" />
          <el-table-column label="合格重量(kg)" prop="PassQuantity2" />
          <el-table-column label="合格数量" prop="PassQuantity" />
          <el-table-column label="不合格重量(kg)" prop="FailQuantity2" />
          <el-table-column label="不合格数量" prop="FailQuantity" />
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button type="text" @click="detail(row)">明细</el-button>
              <el-button type="text" @click="undoOnce(row)">撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <report-dialog ref="editDialog" @saved="saved" :displayMode="displayMode"> </report-dialog>
    <report-test-dialog ref="reportTestDialog" @saved="saved" :displayMode="displayMode"> </report-test-dialog>
    <!-- 
    <report-info-dialog ref="reportInfoDialog" @saved="saved" :displayMode="displayMode"> </report-info-dialog> -->
  </div>
</template> 
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import reportDialog from '@/components/production/reportmanagement/prewarehousing/toPro/reportDialog'
import reportTestDialog from '@/components/production/reportmanagement/prewarehousing/toPro/reportTestDialog'
// import reportInfoDialog from '@/components/production/reportmanagement/report/toPro/reportInfoDialog'
import curdMixins from '@/mixins/trend/curd'

export default {
  mixins: [listMixin, curdMixins],
  components: {
    list,
    reportDialog,
    reportTestDialog
    // reportInfoDialog
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pu/plan').default,
      formApi: require('@/api/sy/formSetting').default,
      tableApi: require('@/api/sy/tableSetting').default,
      queryApi: require('@/api/sy/selectSetting').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      trendShow: true,
      params: {
        CustomerName: '',
        OrderNo: '',
        WorkDocNo: '',
        StartDate: null,
        EndDate: null,
        SourceDtsName: '',
        WorkDocType: null,
        Stage: '0',
        ToPeport: true
      },
      tabName: '0',
      tabName1: 'report',
      mode: 1,
      tempParams: {
        IsWaitIn: true,
        Stage: 0
      },
      infoData: [],
      reportData: [],
      checkList: [],
      displayMode: 1,
      machiningStageList: [],
      stageList: [],
      zscount: 0,
      selectRow: {}
    }
  },
  computed: {
    name() {
      if (this.tabName == '0') return '模具'
      if (this.tabName == '1') return '胶件'
      if (this.tabName == '2') return '配件'
      if (this.tabName == '3') return '产品'
      if (this.tabName == '4') return '产品'
      return ''
    }
  },
  mounted() {},
  created() {
    this.getStageData()
  },
  methods: {
    undoOnce(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .cancelOnce({ workDocId: row.WorkDocId, planDtsId: row.PlanDtsId, reportId: row.ReportId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$refs.list.reload()
            this.$message.success(res.Msg)
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    detail(row) {
      this.api.getReportInfo({ Id: row.ReportId }).then(res => {
        if (res.Code == 0) {
          var data = res.Data
          console.log(data, 'getReportInfo', this.$refs)
          //this.$refs.reportInfoDialog.openEdit(data)
        }
      })
    },
    getStageData() {
      // this.machiningStageApi.list({ Status: 1, Universal: true }).then(res => {
      //   this.machiningStageList = res.Data
      //   this.machiningStageList.forEach(x => {
      //     x.Count = 0
      //   })

      // })
      console.log(this.$refs.list, this.$refs.list.queryParams, 'list')
      var params = { ...this.params, ...this.tempParams, ...this.$refs.list.queryParams }
      params = this.$commonJs.obj.removeNullKey(params)
      this.api.getStageList(params).then(ret => {
        this.stageList = ret.Data
      })
    },
    reload() {
      this.$refs.list.reload()
      this.getStageData()
      // if (this.tabName === '0') {
      //   this.$refs['info0'].clear()
      // } else {
      //   this.$refs['info1'].clear()
      // }
    },
    tabClick() {
      // console.log("tab", this.tabName);
      this.infoData = []
      this.reportData = []
      // this.$refs.list.getData({ Stage: this.tabName });
      this.tempParams.Stage = Number(this.tabName)
      this.$refs.list.getData()
      this.getStageData()
      this.displayMode = 2
      if (this.tabName === '0') {
        //this.$refs.list.setTable(this.Injection);
        this.displayMode = 1
      }
      // if (this.tabName === "1") {
      //   this.$refs.list.setTable(this.Special);
      //   this.displayMode = 2;
      // }
      // if (this.tabName === "2") {
      //   this.$refs.list.setTable(this.Parts);
      //   this.displayMode = 2;
      // }
      // if (this.tabName === "3") {
      //   this.$refs.list.setTable(this.Assembling);
      //   this.displayMode = 2;
      // }
      // if (this.tabName === "4") {
      //   this.$refs.list.setTable(this.Combination);
      //   this.displayMode = 2;
      // }
      this.$emit('tabChange', this.tabName)
    },
    getDataEnd(resData) {
      this.getStageData()
      this.infoData = []
      this.reportData = []
      console.log('getDataEnd ==== resData', resData)
      let Combination = []
      let Assembling = []
      let Parts = []
      let Special = []
      let Injection = []

      let data = resData
      let length = data.length

      for (let i = 0; i < length; ++i) {
        let stage = data[i].Stage
        switch (stage) {
          case 0:
            Injection.push(data[i])
            break
          case 1:
            Special.push(data[i])
            break
          case 2:
            Parts.push(data[i])
            break
          case 3:
            Assembling.push(data[i])
            break
          case 4:
            Combination.push(data[i])
            break
        }
      }

      this.Combination = Combination
      this.Assembling = Assembling
      this.Parts = Parts
      this.Special = Special
      this.Injection = Injection

      if (this.tabName === '0') this.$refs.list.setTable(this.Injection)
      if (this.tabName === '1') this.$refs.list.setTable(this.Special)
      if (this.tabName === '2') this.$refs.list.setTable(this.Parts)
      if (this.tabName === '3') this.$refs.list.setTable(this.Assembling)
      if (this.tabName === '4') this.$refs.list.setTable(this.Combination)
      if (this.selectRow) {
        var row = data.find(x => x.PlanDtsId == this.selectRow.PlanDtsId)
        if (row) this.onSelect(row)
      }
    },
    onSelect(row) {
      // this.$refs["info" + this.tabName].setData(row.PlanId);
      this.infoData = []
      // this.api
      //   .getWorkDocReportList({
      //     WorkDocId: row.WorkDocId,
      //     WorkDocNo: row.WorkDocNo,
      //     PlanDtsId: row.PlanDtsId
      //   })
      //   .then(res => {
      //     if (res.Data && JSON.stringify(res.Data) !== '{}') {
      //       this.infoData = [res.Data]
      //     }
      //   })
      //   .catch(err => {
      //     this.$message.error(err)
      //     // console.log(err);
      //   })
      // this.api
      //   .getReortList({ PlanDtsId: row.PlanDtsId })
      //   .then(res => {
      //     if (res.Data && JSON.stringify(res.Data) !== '{}') {
      //       this.reportData = res.Data
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    },
    // edit(row) {
    //   var name = "edit" + this.tabName + "Dialog";
    //   this.$refs[name].openCreate({ ...row, Stage: this.tabName });
    // },
    report(row) {
      this.edit(row)
    },
    onCheck(data) {
      this.checkList = data
    },
    saved() {
      this.$refs.list.query()
      this.getStageData()
    },

    reportTest(row) {
      console.log(this.$refs, 'reportTest', row, 'row')
      this.selectRow = row
      this.$refs.reportTestDialog.openEdit(row)
      //this.edit({row:row,batch:false})
    }
  }
}
</script>